module.exports = __webpack_public_path__ + "images/for_company_page/point2-1_474374dcb6df4f504b9084894a1f74f8.jpg";